import axios from "axios";

const state = {
  organisationId: null,
  cancellationReasons: {},
  websitesWithPublishedChanges: [],
  currentStep: 1,
  maxSteps: 2,
  validationErrors: {},
  isPackage: false,
  isAnnual: false,
  hasDiscountApplied: false,
  maxNumberOfDiscountsApplied: 0,
};

const getters = {
  organisationId: ({organisationId}) => organisationId,
  websitesWithPublishedChanges: ({websitesWithPublishedChanges}) => websitesWithPublishedChanges,
  cancellationReasons: ({cancellationReasons}) => cancellationReasons,
  currentStep: ({currentStep}) => currentStep,
  validationErrors: ({validationErrors}) => validationErrors,
  endpointPrefix: ({isPackage}) => isPackage ? '/ajax/v2/settings/package' : '/settings/agency',
  isPackage: ({isPackage}) => isPackage,
  isAnnual: ({isAnnual}) => isAnnual,
  hasDiscountApplied: ({hasDiscountApplied}) => hasDiscountApplied,
  maxNumberOfDiscountsApplied: ({maxNumberOfDiscountsApplied}) => maxNumberOfDiscountsApplied,
};

const mutations = {
  setOrganisationId: (state, id) => state.organisationId = id,
  setWebsitesWithPublishedChanges: (state, websites) => state.websitesWithPublishedChanges = websites,
  setValidationErrors: (state, errors) => state.validationErrors = errors,
  setCancellationReasons: (state, reasons) => state.cancellationReasons = reasons,
  setIsPackage: (state, isPackage) => state.isPackage = isPackage,
  setIsAnnual: (state, isAnnual) => state.isAnnual = isAnnual,
  setHasDiscountApplied: (state, hasDiscountApplied) => state.hasDiscountApplied = hasDiscountApplied,
  setMaxNumberOfDiscountsApplied: (state, maxNumberOfDiscountsApplied) => state.maxNumberOfDiscountsApplied = maxNumberOfDiscountsApplied,
  setCurrentStep: (state, step) => {
    if (step <= state.maxSteps){
      state.currentStep = step;
    }
  },
};

const actions = {
  setOrganisationId: ({commit}, id) => commit('setOrganisationId', id),
  setWebsitesWithPublishedChanges: ({commit}, websites) => commit('setWebsitesWithPublishedChanges', websites),
  setCancellationReasons: ({commit}, reasons) => commit('setCancellationReasons', reasons),
  setIsPackage: ({commit}, isPackage) => commit('setIsPackage', isPackage),
  setIsAnnual: ({commit}, isAnnual) => commit('setIsAnnual', isAnnual),
  setHasDiscountApplied: ({commit}, hasDiscountApplied) => commit('setHasDiscountApplied', hasDiscountApplied),
  setMaxNumberOfDiscountsApplied: ({commit}, maxNumberOfDiscountsApplied) => commit('setMaxNumberOfDiscountsApplied', maxNumberOfDiscountsApplied),
  submitCancellationForm: ({commit, getters},{cancellationReason, whatToImprove}) => {
    return new Promise((resolve, reject) => {
      axios.post(`${getters.endpointPrefix}/${getters.organisationId}/cancel`, {
        cancellation_reason: cancellationReason,
        what_to_improve: whatToImprove,
      })
        .then(() => resolve())
        .catch((error) => {
          const {response} = error;

          if (response?.status === 422) {
            commit('setValidationErrors', response.data.errors);
          }

          reject(error);
        });
    });
  },
  nextStep: ({commit}) => commit('setCurrentStep', state.currentStep + 1),
  previousStep: ({commit, getters}) => {
    if (getters.currentStep === 1 || getters.websitesWithPublishedChanges.length === 0) {
      window.location = '/settings#account';
      return;
    }
    commit('setCurrentStep', getters.currentStep - 1);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
